import ColorThief from 'colorthief'
import { useEffect, useState } from 'react'
import ProfileRegistry from '../../../stores/registry/ProfileRegistry'

const DEFAULT_COLOR = '#b7afed'

export const rgbToHex = (rgb: number[]) =>
  '#' +
  rgb
    .map((x) => {
      const hex = x.toString(16)
      return hex.length === 1 ? '0' + hex : hex
    })
    .join('')

const useProfileBannerColor = (wallet_address: string) => {
  const [color, setColor] = useState<string>()
  const ct = new ColorThief()

  useEffect(() => {
    ProfileRegistry.getByIndexAsync(wallet_address).then((profile) => {
      const pfpURL = profile?.profile_picture
      if (!pfpURL) {
        setColor(DEFAULT_COLOR)
        return
      }

      const img = document.createElement('img')
      img.crossOrigin = 'anonymous'
      img.src = pfpURL
      setColor(DEFAULT_COLOR)
      img.addEventListener('load', () => {
        const imgColor = ct.getColor(img)
        const hex = rgbToHex(imgColor)
        setColor(hex)
      })
    })
  }, [wallet_address])

  return color
}

export default useProfileBannerColor
